import { gql } from 'graphql-request'

export default {
  addBlockReason: gql`
    mutation addBlockReason($blockReason: AddBlockReason) {
      addBlockReason(blockReason: $blockReason)
    }
  `,
  deleteBlockReason: gql`
    mutation deleteBlockReason($id: Int!) {
      deleteBlockReason(id: $id)
    }
  `,
}
